import React from "react";
import { OptionsIcon } from "@fluentui/react-icons-northstar";
import { ReportFilterBase } from "./abstractions/ReportFilterBase";
import { Segment } from "../models";

export interface SegmentsFilterProps {
    segmentList: Segment[];
    onSelectedSegmentsChanged: (segmentList: Segment[]) => void;
    isMobileView: boolean;
    atLeastOneAlwaysSelected: boolean;
    multiple: boolean;
    prefix: string;
}

export const SegmentsFilter: React.FC<SegmentsFilterProps> = ({
    segmentList,
    onSelectedSegmentsChanged,
    isMobileView,
    atLeastOneAlwaysSelected,
    multiple,
    prefix,
}) => {
    return (
        <ReportFilterBase
            icon={<OptionsIcon outline />}
            prefix={`Segment ${prefix}`}
            multiple={multiple}
            items={segmentList}
            onSelectedItemsChanged={(segments) => {
                onSelectedSegmentsChanged(segments as Segment[]);
            }}
            isMobileView={isMobileView}
            atLeastOneAlwaysSelected={atLeastOneAlwaysSelected}
        />
    );
};
